
<template>
  <vs-sidebar click-not-close parent="#tranksaksi-app" :hidden-background="true" class="full-vs-sidebar tranksaksi-view-sidebar items-no-padding" v-model="isPembayaranActive" position-right>
    <div class="px-0 sm:pb-6 h-full tranksaksi-area-loading">
      <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg tranksaksi-header">
        <div class="flex">
          <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="pembayaranAddClose" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
          <vs-button type="line" @click="pilihList">List Pembayaran</vs-button>
        </div>
        <vs-button type="line" color="danger" @click="pilihTidakList">Trash</vs-button>
      </div>

      <component :is="scrollbarTag" class="tranksaksi-scroll-area md:p-8 p-6" :settings="settings" :key="$vs.rtl">
        <vx-card id="pembayaran-load" v-if="list_status">
          <div slot="no-body">
            <div class="flex justify-between items-center py-3 px-6 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
              <h5>Sisa Tagihan {{sisaPembayaran | currency}}</h5>
              <vs-button color="primary" size="small" icon-pack="feather" icon="icon-plus" v-on:click="openBayar()" v-if="data.status_lunas != 'Lunas Sudah'">Update</vs-button>
            </div>
          </div>
          <div>
            <transition-group name="list-enter-up" tag="ul" appear>
              <li
                class="cursor-pointer"
                v-for="(list, index) in listPembayaran" :key="index"
                :style="[{transitionDelay: (index * 0.1) + 's'}]"
                @click="openView(list)">
                <div class="px-4 py-3 list-item-component-no-border">
                  <div class="vx-row"  >
                    <div class="vx-col w-full sm:w-2/3 sm:items-center sm:flex-row flex-col">
                      <div class="progress-tags flex">
                        <span class="flex items-center rounded">
                          <div class="h-3 w-3 rounded-full mr-2 bg-success"></div>{{ list.task_title}}
                        </span>
                      </div>
                      <h6 class="progress-title items-center sm:ml-5">{{ list.tanggal }}</h6>
                    </div>
                    <div class="vx-col w-full sm:w-1/3 items-center pt-2">
                      <h5 class="truncate">{{ list.task_total | currency}}</h5>
                    </div>
                  </div>
                </div>
              </li>
            </transition-group>
          </div>
        </vx-card>
        <vx-card id="pembayaran-load" v-else>
          <div slot="no-body">
            <div class="flex justify-between items-center py-3 px-6 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
              <h5>Trash</h5>
            </div>
          </div>
          <div>
            <transition-group name="list-enter-up" tag="ul" appear>
              <li
                class="cursor-pointer"
                v-for="(list, index) in listPembayaran" :key="index"
                :style="[{transitionDelay: (index * 0.1) + 's'}]"
                @click="openView(list)">
                <div class="px-4 py-3 list-item-component-no-border">
                  <div class="vx-row"  >
                    <div class="vx-col w-full sm:w-2/3 sm:items-center sm:flex-row flex-col">
                      <div class="progress-tags flex">
                        <span class="flex items-center rounded">
                          <div class="h-3 w-3 rounded-full mr-2 bg-success"></div>{{ list.task_title}}
                        </span>
                      </div>
                      <h6 class="progress-title items-center sm:ml-5">{{ list.tanggal }}</h6>
                    </div>
                    <div class="vx-col w-full sm:w-1/3 items-center pt-2">
                      <h5 class="truncate">{{ list.task_total | currency}}</h5>
                    </div>
                  </div>
                </div>
              </li>
            </transition-group>
          </div>
        </vx-card>
      </component>
    </div>

    <bayar :isBayarActive="isBayarActive" @closeBayar="closeBayar" :data="bayarData" :dataFrom="data" :tranksaksi="tranksaksi" :status="list_status"></bayar>

  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import Bayar from '../term/Bayar.vue'

export default {
  props: {
    isPembayaranActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    tranksaksi: {
      type: String,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    Bayar
  },
  data () {
    return {
      isBayarActive : false,
      bayarData : {},
      list_status: true,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isPembayaranActive (val) {
      if (!val) { return } else {
        if (Object.entries(this.data).length != 0) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#pembayaran-load',
            type: 'sound',
            scale: 0.45
          })
          const obj = {
            id: this.data.id,
            total: this.data.task_total
          }
          this.$store.dispatch(this.tranksaksi+'/fetchPembayaran', obj)
          if (this.listPembayaran.length > 0 || this.listPembayaran.length === 0) {
            setTimeout(() => {
              this.$vs.loading.close('#pembayaran-load > .con-vs-loading')
            }, 2000)
          }
        }
      }
    }
  },
  computed: {
    isPembayaranActiveLocal: {
      get () {
        return this.isPembayaranActive
      },
      set (val) {
        if (!val) {
          this.$emit('closePembayaran')
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
    listPembayaran() {
      if (this.tranksaksi === 'pembelian') {
        return this.$store.state.pembelian.pembayarans
      } else if (this.tranksaksi === 'biaya') {
        return this.$store.state.biaya.pembayarans
      } else if (this.tranksaksi === 'sewa') {
        return this.$store.state.sewa.pembayarans
      } else if (this.tranksaksi === 'penjualan') {
        return this.$store.state.penjualan.pembayarans
      } else if (this.tranksaksi === 'kas') {
        return this.$store.state.kas.pembayarans
      }
    },
    sisaPembayaran() {
      if (this.tranksaksi === 'pembelian') {
        return this.$store.state.pembelian.pembayaran_sisa
      } else if (this.tranksaksi === 'biaya') {
        return this.$store.state.biaya.pembayaran_sisa
      } else if (this.tranksaksi === 'sewa') {
        return this.$store.state.sewa.pembayaran_sisa
      } else if (this.tranksaksi === 'penjualan') {
        return this.$store.state.penjualan.pembayaran_sisa
      } else if (this.tranksaksi === 'kas') {
        return this.$store.state.kas.pembayaran_sisa
      }
    },
    totalPembayaran() {
      if (this.tranksaksi === 'pembelian') {
        return this.$store.state.pembelian.pembayaran_total
      } else if (this.tranksaksi === 'biaya') {
        return this.$store.state.biaya.pembayaran_total
      } else if (this.tranksaksi === 'sewa') {
        return this.$store.state.sewa.pembayaran_total
      } else if (this.tranksaksi === 'penjualan') {
        return this.$store.state.penjualan.pembayaran_total
      } else if (this.tranksaksi === 'kas') {
        return this.$store.state.kas.pembayaran_total
      }
    },
    statusPembayaran() {
      if (this.tranksaksi === 'pembelian') {
        return this.$store.state.pembelian.pembayaran_status
      } else if (this.tranksaksi === 'biaya') {
        return this.$store.state.biaya.pembayaran_status
      } else if (this.tranksaksi === 'sewa') {
        return this.$store.state.sewa.pembayaran_status
      } else if (this.tranksaksi === 'penjualan') {
        return this.$store.state.penjualan.pembayaran_status
      } else if (this.tranksaksi === 'kas') {
        return this.$store.state.kas.pembayaran_status
      }
    }
  },
  mounted(){
  },
  beforeDestroy () {
  },
  methods: {
    pilihList() {
      this.list_status = true
      if (Object.entries(this.data).length != 0) {
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#pembayaran-load',
          type: 'sound',
          scale: 0.45
        })
        const obj = {
          id: this.data.id,
          total: this.data.task_total
        }
        this.$store.commit(this.tranksaksi+'/SET_NULL_PEMBAYARAN')
        this.$store.dispatch(this.tranksaksi+'/fetchPembayaran', obj)
        if (this.listPembayaran.length > 0 || this.listPembayaran.length === 0) {
          setTimeout(() => {
            this.$vs.loading.close('#pembayaran-load > .con-vs-loading')
          }, 2000)
        }
      }
    },
    pilihTidakList() {
      this.list_status = false
      if (Object.entries(this.data).length != 0) {
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#pembayaran-load',
          type: 'sound',
          scale: 0.45
        })
        const obj = {
          id: this.data.id,
          total: this.data.task_total
        }
        this.$store.commit(this.tranksaksi+'/SET_NULL_PEMBAYARAN')
        this.$store.dispatch(this.tranksaksi+'/fetchPembayaranTrash', obj)
        if (this.listPembayaran.length > 0 || this.listPembayaran.length === 0) {
          setTimeout(() => {
            this.$vs.loading.close('#pembayaran-load > .con-vs-loading')
          }, 2000)
        }
      }
    },
    persen(val) {
      return parseInt(val)
    },
    openBayar() {
      this.isBayarActive = true
    },
    openView(data) {
      this.isBayarActive = true
      this.bayarData = data
    },
    closeBayar() {
      this.isBayarActive = false
    },
    pembayaranAddClose() {
      this.$emit('closePembayaran')
    }
  }
}
</script>
